<template lang="html">
  <b-row class="top-banner mb-2 align-middle">
  <b-modal size="lg" hide-footer title="Methodology" id="methodology">
    <div v-html="methodology"></div>
  </b-modal>
    <b-col cols="12" class="d-md-none d-sm-block">
      <b-breadcrumb class="mb-0 pl-0 pb-0" :items="breadcrumbList"></b-breadcrumb>
    </b-col>
    <b-col>
      <h2 class="heading mt-1">{{ heading }}</h2>
      <slot name="subtitle"></slot>
    </b-col>
    <b-col v-if="methodology" cols="12" sm="6">
      <b-button v-b-modal.methodology class="methodology-toggle float-right elementor-button">See Our Methodology</b-button>
      <font-awesome-icon @click="print" class="printButton float-right mr-4 mt-1 d-none d-md-block" icon="print" size="2x" />
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: ['methodology', 'heading'],
  methods: {
    print: function() {
      this.$emit('print')
      /* location.hash = '#printTableau'; */
    }
  },
  computed: {
    breadcrumbList: function() {
      return this.$route.meta.breadcrumb
    }
  }
}
</script>
<style scoped>
.breadcrumb {
  background-color: transparent;
}

.subtitle {
  font-size: 1rem;
}

.breadcrumb-item a,
.breadcrumb-item.active,
.breadcrumb-item.active span {
  color: white;
}

a:hover {
  text-decoration: none
}
</style>
<style lang="css">
* {
  //font-family: "freight-sans-pro", Sans Source;
}

.modal-header {
  border-bottom: 1px solid black !important;
  padding-bottom: 0.25rem;

}

.heading {
  font-size: 1.5rem;
  font-weight: 600;
  color: white;
  margin-bottom: 0;
  font-family: "freight-sans-pro", Sans Source;
}

#headerCaption {
  font-size: 0.8rem;
  font-weight: 500;
  color: white;
  font-family: "freight-sans-pro", Sans Source;
}

.printButton {
  cursor: pointer;
}

.svg-inline--fa.fa-w-16 {
  width:0.8em;
}

.btn.methodology-toggle {
  font-weight: 500;
  font-size: 0.8rem;
  background-color: #61bce2;
  border-style: solid;
  border-width: 2px 2px 2px 2px;
  border-color: #61bce2;
  box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.3);
  padding: 0.6rem 1.3rem;
}

@media (max-width: 576px) {
  .btn.methodology-toggle {
    width: 100%;
    margin-top: 25px;
    margin-bottom: 10px;
  }
}

.btn.methodology-toggle:hover {
  background-color: #2babe2;
  border-color: #2babe2;
}

.modal-body {
  font-size: 0.9rem;
}

.modal-header h5 {
  font-size: 1.5rem;
  font-weight: 600;
}
</style>
